export default __webpack_public_path__ + "45881e2c22009bfe2d08dc9985fa81ed.svg";